import * as a from "react";
const e = (l) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M16 9.012a1 1 0 01.92.608l5 12a1 1 0 01-1.84.76L18.67 19h-5.34l-1.4 3.38a1 1 0 11-1.85-.76l5-12a1 1 0 01.92-.608zm0 3.588L14.17 17h3.66L16 12.6zM9 2a1 1 0 011 1v1h5a1 1 0 110 2h-2.02a7 7 0 01-2.03 4.46l-.54.54 1.3 1.3a1 1 0 01-1.42 1.4L9 12.42l-3.3 3.3a1 1 0 11-1.4-1.42L7.58 11l-1.3-1.3A1 1 0 017.7 8.3L9 9.58l.54-.54A5 5 0 0010.98 6H3a1 1 0 010-2h5V3a1 1 0 011-1z",
      fill: "#2d6ded"
    }
  )
), t = e;
export {
  t as default
};
